<template>
  <div>

    <div class="row mt-5">
      <div class="col-lg-12 col-sm-12">
        <p class="text-center" v-scrollanimation><span>Fotoğraf Galerisi</span></p>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3 col-sm-6 mt-5  "
         @click.prevent="show(i)"
         v-for="(img, i) in images"
        :key="i"
        role="button">
        <img class="card-img-top rounded opacity" alt="Ayancık Adak" :src="img" height="200"  />
      </div>
    </div>

    <div
      class="lightbox col-md-12 fixed-top "
      v-if="visible"
      @click="hide"
      role="button"
    >
      <div class="row">
        <div
          role="button"
          class="col-md-11 text-right text-white display-4 "
          @click.stop="hide"
        >
          &times;
          <!-- // X işareti -->
        </div>
      </div>
      <div class="row">
        <div class="row mx-auto vh-100">
          <div
            role="button"
            class="carousel-control-prev col-md-1"
            @click.stop="prev"
            :class="{ invisible: !hasPrev() }"
          >
            <span class="carousel-control-prev-icon "></span>
          </div>
          <div class="col-md-12">
            <img :src="images[index]" id="galeri" alt="Ayancık Adak" class="rounded img-fluid" />
          </div>
          <div
            class="carousel-control-next col-md-1"
            @click.stop="next"
            :class="{ invisible: !hasNext() }"
            role="button"
          >
            <span class="carousel-control-next-icon "></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      index: 0,
      images: [
        "public/photos/ayancikadak (1).jpg",
        "public/photos/ayancikadak (2).jpg",
        "public/photos/ayancikadak (3).jpg",
        "public/photos/ayancikadak (4).jpg",
        "public/photos/ayancikadak (5).jpg",
        "public/photos/ayancikadak (6).jpg",
        "public/photos/ayancikadak (7).jpg",
        "public/photos/ayancikadak (9).jpg",
        "public/photos/ayancikadak (10).jpg",
        "public/photos/ayancikadak (11).jpg",
        "public/photos/ayancikadak (12).jpg",
        "public/photos/ayancikadak (13).jpg",
        "public/photos/ayancikadak (14).jpg",
        "public/photos/ayancikadak (15).jpg",
        "public/photos/ayancikadak (16).jpg"
      ]
    };
  },
 
  methods: {
    show(index) {
      this.visible = true;
      this.index = index;
    },
    hide() {
      this.visible = false;
      this.index = 0;
    },
    hasNext() {
      return this.index + 1 < this.images.length;
    },
    hasPrev() {
      return this.index - 1 >= 0;
    },
    next() {
      if (this.hasNext()) {
        this.index += 1;
      }
    },
    prev() {
      if (this.hasPrev()) {
        this.index -= 1;
      }
    },
    onKeydown(e) {
      if (this.visible) {
        switch (e.key) {
          case "ArrowRight":
            this.next();
            break;
          case "ArrowLeft":
            this.prev();
            break;
          case "ArrowDown":
          case "ArrowUp":
          case " ":
            e.preventDefault();
            break;
          case "Escape":
            this.hide();
            break;
        }
      }
    }
  }
};
</script>

<style scoped>
p {
  background-color: #333;
  width: 70%;
  margin: auto;
  border-radius: 10px;
}
p > span {
  font-size: 40px;
  color: white;
}

.lightbox {
  background: rgba(0, 0, 0, 0.8);
}
.carousel-control-next {
  width: 50px;
  background-color: rgb(22, 153, 77, 0.8);
  height: 50px;
  margin-top: 15rem !important;
}
.carousel-control-prev {
  width: 50px;
  background-color: rgb(22, 153, 77, 0.8);
  height: 50px;
  margin-top: 15rem !important;
}
.opacity{
   transition:opacity 1s ease;
}
.opacity:hover{
  opacity: 0.5;
  transition:opacity 1s ease
}

.before-enter {
  opacity: 0;
  transform: scale(0);
  transition: all 0.5s ease-in;
}
.enter {
  opacity: 1;
  transform: scale(1);
}


@media only screen and (max-width: 600px) {
  #galeri {
    margin-top: 5rem;
    width: 500px;
    height: 250px;
  }
}
@media only screen and (min-width: 600px) {
  #galeri {
    width: 700px;
    height: 500px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Galery.vue